import React from 'react';
import styled from 'styled-components';

import VaultIconSvg from 'components/vaults/images/VaultIconSvg';
import { useOwnVaultQuery } from 'components/vaults/shared/utils';
import { useSelector } from 'reduxState/store';

import { MenuItemType } from '../headerTypes';
import MenuItemRenderer from '../MenuItemRenderer';

const TruncatedVaultName = styled.span`
  max-width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Vault owner Link (Optional) */
function VaultOwnerItem() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const ownVault = useOwnVaultQuery();

  if (!ownVault || !walletAddress) {
    return null;
  }

  return (
    <MenuItemRenderer
      menuItem={{
        type: 'DropdownMenuLink' as const,
        label: (
          <TruncatedVaultName>{ownVault.name || 'My Vault'}</TruncatedVaultName>
        ),
        paddingRight: '0px',
        to: `/vaults/${walletAddress}`,
        icon: <VaultIconSvg color="currentColor" size={17} />,
      }}
    />
  );
}

const vaultOwnerItem: MenuItemType = {
  type: 'MenuBox',
  Component: VaultOwnerItem,
};

export default vaultOwnerItem;
